import styled from 'styled-components'
import {
  H1 as H1CL,
  H2 as H2CL,
  H3 as H3CL
} from 'syf-component-library/ui/typography'
import query from 'mediaQueries'

export const Page = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  @media ${query.greaterThanMedium} {
    flex-direction: row;
  }
`

export const MainContent = styled.div`
  flex: 1;
`

export const Container = styled.div`
  padding: 64px 16px;
  background-color: ${({ theme }): string => theme.assistanceBackground};
  color: ${({ theme }) => theme.greyEighty};
  max-width: 100%;
  @media ${query.greaterThanMedium} {
    padding: 64px 32px;
    max-width: 360px;
  }
`

export const Title = styled(H1CL)`
  margin: 0;
  font-size: 16px;
`

export const Header = styled(H2CL)`
  margin: 32px 0;
  font-size: 24px;
`

export const PhoneNumbers = styled.div`
  margin: 0 0 32px;
`

export const SectionTitle = styled(H3CL)`
  margin: 16px 0 8px;
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.brightGrey};
`

export const Text = styled.p`
  margin: 0;
`

export const BusinessHoursGrid = styled.div`
  display: grid;
  row-gap: 0.25em;
  column-gap: 0.5em;
  grid-template-columns: 9em 1fr;
`
